import React from "react";
import "./default.scss";
import BaseSwitch from "./pages/BaseSwitch";

function App() {
  return <BaseSwitch />;
}

export default App;
